module.exports = __webpack_public_path__ + "static/the-joy-luck-club-0c67d5a0a193f69fe2caff3ee82111c6.jpg";